import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const getAllMotivosRetencion = async () => {
    try {
        const response = await mainAxios.get(
            `/v1/motivos_retencion/`,
            getDefaultHeaders()
        );

        return response.data.data;
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};

export const getMotivosRetencion = async (filters) => {
    try {
        const response = await mainAxios.post(
            `/v1/motivos_retencion/filtros`,
            filters,
            getDefaultHeaders()
        );

        return response.data.data;
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};
